import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import SectionTitle from 'components/ui/typography/SectionTitle';
import {
  dateFilterOperators,
  filterOperators
} from '../../../../components/enhanced/data-grid/utils/filters';
import { useTranslation } from 'react-i18next';
import { baseCell } from '../../../../components/cells';
import { MODELS_MAPS } from '../config/modelsMap';

export function useLogsColumns(onOpenDialog: (id: number) => void): GridColDef[] {
  const { t } = useTranslation();
  const columns: GridColDef[] = [
    {
      field: 'id',
      headerName: t(`global.version_id`),
      filterOperators,
      width: 100,
      renderCell: (params) => {
        const actionRaw = params.row?.action;
        const isDelete = String(actionRaw ?? '')
          .trim()
          .toLowerCase()
          .includes('delete');
        if (isDelete) {
          return <SectionTitle>{params.row.id}</SectionTitle>;
        }
        return (
          <div
            onClick={() => onOpenDialog(params.row.id)}
            style={{ cursor: 'pointer', color: '#1976d2' }}>
            <SectionTitle>{params.row.id}</SectionTitle>
          </div>
        );
      }
    },
    {
      field: 'model_name',
      headerName: t(`global.model`),
      filterOperators,
      width: 200,
      renderCell: (params: GridRenderCellParams) => {
        const code = String(params.value ?? '').trim();
        if (!code) return baseCell(params);
        return <span>{MODELS_MAPS[code]?.label ?? code}</span>;
      }
    },
    {
      field: 'action',
      headerName: t(`global.action`),
      filterOperators,
      width: 100,
      renderCell: baseCell
    },
    {
      field: 'timestamp',
      headerName: t(`global.dates`),
      filterOperators: dateFilterOperators,
      width: 150,
      renderCell: (params: GridRenderCellParams) => {
        const date = new Date(params.value as string);
        return date.toLocaleString('default', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        });
      }
    }
  ];
  return columns;
}
